require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactNative = require("react-native-web/dist/index");

var _platform = require("./../variables/platform");

var _platform2 = _interopRequireDefault(_platform);

var _commonColor = require("./../variables/commonColor");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = function () {
  var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _platform2["default"];
  var platformStyle = variables.platformStyle;
  var tabContainerTheme = {
    elevation: 3,
    height: 50,
    flexDirection: 'row',
    shadowColor: platformStyle === _commonColor.PLATFORM.MATERIAL ? '#000' : undefined,
    shadowOffset: platformStyle === _commonColor.PLATFORM.MATERIAL ? {
      width: 0,
      height: 2
    } : undefined,
    shadowOpacity: platformStyle === _commonColor.PLATFORM.MATERIAL ? 0.2 : undefined,
    shadowRadius: platformStyle === _commonColor.PLATFORM.MATERIAL ? 1.2 : undefined,
    justifyContent: 'space-around',
    borderBottomWidth: _reactNative.Platform.OS === _commonColor.PLATFORM.IOS ? variables.borderWidth : 0,
    borderColor: variables.topTabBarBorderColor
  };
  return tabContainerTheme;
};